import noImage from "assets/images/no-image.jpg";
import whishlist from "assets/pictures/noun-love-4726271.svg";
import cart from "assets/pictures/Path-13479.svg";
import { addToWishlist } from "components/wishlist";

import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { add } from "store/cart/actions";
import notification from "utilities/notification";
import BrandQuery from "./BrandQuery";
import useCart from "hooks/useCart"; // adjust path as needed

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { brands } = BrandQuery();
  const coverImage = product?.image || noImage;
  const onError = (e) => {
    e.target.src = noImage;
  };
  const { items: cartItems } = useCart();
  const existingCartItem = cartItems.find(
    (item) => item.product_id === product?.id
  );
  const addToCart = () => {
    const existingQty = existingCartItem?.quantity || 0;
    const maxQty = product?.inventory_count || 0;

    // Check for max per-user limit
    if (existingQty >= 6) {
      notification("warning", "You can only add up to 6 of this item.");
      return;
    }

    // Check for inventory limit
    if (existingQty >= maxQty) {
      notification("warning", "Maximum stock limit reached");
      return;
    }

    const data = {
      id: product?.id || 0,
      product_id: product?.id || 0,
      name: product?.name || "",
      brands: product?.brands || "",
      price:
        Number(product?.sale_price) > 0
          ? Number(product?.sale_price)
          : Number(product?.normal_price),
      quantity: 1,
      model: product || {},
    };

    dispatch(add(data));
    notification("success", "Product Added To Cart");
  };

  return (
    <Fragment>
      <div className="col-lg-4 g-0 col-md-6 col-sm-6 col-6 text-center">
        <div className="card mt-3 mb-4">
          <Link className="p-1" to={`/products/${product?.id}`} target="_blank">
            <img
              src={coverImage}
              onError={onError}
              alt=""
              // onClick={(e) => navigate(`/products/${product?.id}`)}
              style={{
                cursor: "pointer",
                height: "250px",
                fontWeight: "bold",
                objectFit: "contain",
                width: "100%",
              }}
            />
          </Link>
          <h6 className="line-clamp" style={{ fontWeight: "bold" }}>
            {product?.brand?.name}{" "}
          </h6>
          <br></br>

          <h6 className="card-title mb-2" style={{ fontSize: "14px" }}>
            <Link
              className="p-1"
              to={`/products/${product?.id}`}
              target="_blank"
            >
              {product?.name.substring(0, 25) + "..."}
            </Link>
          </h6>

          <div className="price-buy">
            <div className="d-flex gap-16">
              <Link to={`/products/${product?.id}`}>
                <div className="price">₹ {product?.sale_price}</div>
              </Link>
              {product.normal_price > product.sale_price && (
                <del className="del-price">
                  <Link to={`/products/${product?.id}`}>
                    <div className="price">₹ {product?.normal_price}</div>
                  </Link>
                </del>
              )}
            </div>

            <div className="d-flex gap-16 me-3">
              <button className="border-0 p-0 d-none">
                <img
                  src={whishlist}
                  alt=""
                  style={{ height: 18 }}
                  onClick={() => addToWishlist(product?.id)}
                />
              </button>
              <button
                className="border-0 p-0"
                onClick={addToCart}
                disabled={
                  product.inventory_count === 0 ||
                  existingCartItem?.quantity >= product.inventory_count
                }
                title={
                  product.inventory_count === 0
                    ? "Out of Stock"
                    : existingCartItem?.quantity >= product.inventory_count
                    ? "Maximum stock limit reached"
                    : "Add to Cart"
                }
              >
                <img
                  src={cart}
                  alt=""
                  style={{
                    height: 18,
                    opacity:
                      product.inventory_count === 0 ||
                      existingCartItem?.quantity >= product.inventory_count
                        ? 0.5
                        : 1,
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductCard;
